import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';

interface Props {
  title: string;
}

export const SubHeader = ({ title }: Props) => {
  return (
    <Grid item xs={12}>
      <Typography color="primary">
        <strong>{title}</strong>
      </Typography>
    </Grid>
  );
};
